import React from 'react';


function Corousel(props) {


  return (
    <>
    <div className="corousel">
      <div className="corouselContainer">
        
          <div className="corouselImgContainer">
            <img className="corouselImg" src={props.source} alt="hyperContentLife"/>
          </div>

          <div className="corouselContent">
            <div><h1 className="corouselHeading">{props.heading}</h1></div>
            <div><p className="corouselSubHeading">{props.subHeading}</p></div>
          </div>
      </div>
    </div>
    </>
  )
}

export default Corousel